<template>
  <div :class="{ 'overflow-hidden': modalActive }">
    <welcome-line-form :handle-submit="handleSubmit" :open-modal="openModal" />
    <nav-menu :sticky="true" />
    <welcome-hero />
    <welcome-features />
    <welcome-plans />
    <section class="hero is-primary" id="signup">
      <div class="hero-body">
        <div class="columns is-centered">
          <div class="column is-one-third-desktop">
            <h3 class="title">Try it now, for free!</h3>
            <login-signup-tabs :starting-tab="1"></login-signup-tabs>
          </div>
        </div>
        <app-download-links />
      </div>
    </section>
    <tiny-footer />
    <b-modal :active.sync="modalActive" has-modal-card>
      <welcome-modal :line="line" />
    </b-modal>
  </div>
</template>

<script>
import LoginSignupTabs from '@/components/Login/LoginSignupTabs.vue'
import NavMenu from '@/components/NavMenu.vue'
import TinyFooter from '@/components/Footer.vue'
import AppDownloadLinks from '@/components/Welcome/AppDownloadLinks.vue'
import WelcomeFeatures from '@/components/Welcome/WelcomeFeatures.vue'
import WelcomeHero from '@/components/Welcome/WelcomeHero.vue'
import WelcomeLineForm from '@/components/Welcome/WelcomeLineForm.vue'
import WelcomePlans from '@/components/Welcome/WelcomePlans.vue'
import WelcomeModal from '@/components/Welcome/WelcomeModal.vue'

export default {
  name: 'Welcome',
  components: {
    AppDownloadLinks,
    NavMenu,
    LoginSignupTabs,
    TinyFooter,
    WelcomeFeatures,
    WelcomeHero,
    WelcomeLineForm,
    WelcomePlans,
    WelcomeModal,
  },
  methods: {
    openModal() {
      this.modalActive = true
    },
    handleSubmit(line) {
      this.openModal()
      this.line = line
    }
  },
  data() {
    return {
      line: undefined,
      modalActive: false,
    }
  },
};
</script>

<style scoped lang="scss">
.card {
  border-radius: 4px;
}

.quote {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.overflow-hidden {
  overflow: hidden;
}

.title {
  padding-bottom: 30px;
}
</style>
